// Lib
import React from 'react';

// Components
import CloseButton from '../../Button/CloseButton';

const ModalHeader = ({ modalProps, closeIcon, onClose, classes }) => {
  const hasTitle = modalProps?.title || modalProps?.titleElement;

  if (!hasTitle) {
    return (
      closeIcon && <CloseButton onClose={modalProps?.onClose || onClose} />
    );
  }

  return (
    <div className={classes.titleContainer} id="title-container">
      {modalProps.titleElement || (
        <h2 className={classes.title}>{modalProps?.title}</h2>
      )}
      {closeIcon && (
        <CloseButton
          className={classes.closeButton}
          onClose={modalProps?.onClose || onClose}
        />
      )}
    </div>
  );
};

export default ModalHeader;
